import { Card, Typography } from "antd";
import React from "react";
import { Link, Navigate } from "react-router-dom";
import getRoleFromToken from "../../utils/getRoleFromToken";

const Home = () => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));
	const { Title, Paragraph } = Typography;

	if (isLogged) {
		const role = getRoleFromToken();
		return (
			<Navigate
				to={role === "customer" ? "/customer/dashboard" : "/admin/dashboard"}
				replace
			/>
		);
	}

	return (
		<div className='card-row flex justify-center items-center h-[80vh]'>
			<div className='w-4/5 md:[500px]'>
				<Card bordered={false} className='rounded-lg w-full max-w-[30rem] mx-auto'>
					<Title level={2} className='m-3 text-center'>
						JET <span className='text-teal-500'>CRM</span>
					</Title>
					<Paragraph className='text-center text-gray-500 mb-6'>
						All your business needs in one place
					</Paragraph>
					<div className='flex flex-col gap-3'>
						<Link
							to='/admin/auth/login'
							className='bg-teal-600 hover:bg-teal-700 text-white font-semibold py-2 px-4 rounded text-center block'>
							Admin Login
						</Link>
						<Link
							to='/customer/login'
							className='bg-teal-500 hover:bg-teal-600 text-white font-semibold py-2 px-4 rounded text-center block'>
							Customer Login
						</Link>
					</div>
				</Card>
			</div>
		</div>
	);
};

export default Home;
